import UploadIdentityCard from './UploadIdentityCard';

export default UploadIdentityCard;
